import Icon from '../components/Icon.vue'

Icon.register({
  biohazard: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M287.9 112c-18.5 0-36 3.8-52.5 9.5-13.3-10.3-23.6-24.3-29.5-40.7 25.2-10.9 53-16.9 82.1-16.9 29.2 0 57 6.1 82.2 17-5.9 16.4-16.2 30.4-29.5 40.7-16.6-5.8-34.2-9.6-52.8-9.6zM163.6 438.7c-47.5-35.5-79.2-90.7-83.3-153.5 7.3-2.1 14.9-3.1 22.5-3.1 9.2 0 17.9 1.8 26.4 4.6 4.1 44.3 26 83.2 58.9 109.6-4.1 16-12.5 30.6-24.5 42.4zM387.8 396.1c32.7-26.4 54.6-65.1 58.7-109.3 8.6-2.8 17.4-4.7 26.6-4.7 7.5 0 15 1 22.2 3-3.9 62.8-35.6 118-83 153.5-12-11.8-20.4-26.5-24.5-42.5zM501.3 191.1c34.6 20.4 61 53.3 74.1 92.4 1.3 3.7-0.2 7.8-3.5 9.8-3.3 2-7.5 1.3-10-1.6-9.4-10.8-19-19-29.2-25.1-57.3-33.9-130.8-13.7-163.9 45-33.1 58.7-13.4 134 43.9 167.9 10.2 6.1 21.9 10.5 35.8 13.4 3.8 0.8 6.4 4.2 6.4 8.1-0.1 4-2.7 7.3-6.5 8-39.7 7.8-80.6 0.8-115.2-19.7-18-10.6-32.9-24.5-45.3-40.1-12.4 15.6-27.3 29.5-45.3 40.1-34.6 20.5-75.5 27.5-115.2 19.7-3.8-0.7-6.4-4-6.5-8 0-3.9 2.7-7.3 6.4-8.1 13.8-3 25.6-7.3 35.8-13.4 57.3-33.9 77-109.2 43.9-167.9-33.1-58.7-106.6-78.9-163.9-45-10.2 6-19.8 14.3-29.2 25.1-2.5 2.9-6.7 3.6-10 1.6-3.3-2.1-4.8-6.1-3.5-9.8 13.3-39.1 39.7-71.9 74.3-92.4 17.6-10.4 36.4-16.6 55.3-19.9-6.1-17.7-10-36.4-10-56.2 0-41 14.6-80.8 41-112.2 2.5-3 6.6-3.7 10-1.8 3.3 1.9 4.8 6 3.6 9.7-4.4 13.8-6.6 26.4-6.6 38.5 0 67.8 53.8 122.9 120 122.9s120-55.1 120-122.9c0-12.2-2.1-24.7-6.6-38.5-1.2-3.7 0.3-7.8 3.6-9.7 3.4-1.9 7.5-1.2 10 1.8 26.5 31.4 41 71.2 41 112.2 0 19.8-4 38.5-10 56.2 19 3.3 37.7 9.5 55.3 19.9zM287.9 320.1c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/biohazard.js
// module id = 666
// module chunks = 0